import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import scrollTo from '../../utils/scrollTo.js';

var _excluded = ["children", "to", "CustomLink", "className", "hideCobra"];

// These should be left outside the component declaration 2 avoid
// performance losses from creating regex each component call.
var telLinkRegex = /^tel:/;
var jumpLinkRegex = /^#/;
var relativeLinkRegex = /^\/(?!\/)/;
var Link = function Link(_ref) {
  var children = _ref.children,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? null : _ref$to,
    _ref$CustomLink = _ref.CustomLink,
    CustomLink = _ref$CustomLink === void 0 ? null : _ref$CustomLink,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className;
    _ref.hideCobra;
    var props = _objectWithoutProperties(_ref, _excluded);
  var isRelativeLink = relativeLinkRegex.test(to);
  if (isRelativeLink && CustomLink) {
    return /*#__PURE__*/React.createElement(CustomLink, _extends({
      className: className,
      to: to
    }, props), children);
  }
  if (isRelativeLink) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: "leshen-link ".concat(className),
      href: to
    }, props), children);
  }
  var isJumpLink = jumpLinkRegex.test(to);
  if (isJumpLink) {
    return /*#__PURE__*/React.createElement("a", {
      className: "leshen-link ".concat(className),
      href: to,
      onClick: function onClick(e) {
        e.preventDefault();
        scrollTo(to);
      }
    }, children);
  }
  var isTelLink = telLinkRegex.test(to);
  return (
    /*#__PURE__*/
    // The linter fails to recognize that target="_blank" and rel="noopener noreferrer"
    // will always happen together due to them both relying on the same variable.
    // eslint-disable-next-line react/jsx-no-target-blank
    React.createElement(React.Fragment, null, to ? /*#__PURE__*/React.createElement("a", _extends({
      className: "leshen-link ".concat(className),
      href: to,
      target: isTelLink ? null : '_blank',
      rel: isTelLink ? null : 'noopener noreferrer'
    }, props), children) : /*#__PURE__*/React.createElement("span", _extends({
      className: "leshen-link ".concat(className)
    }, props), children))
  );
};
var Link$1 = Link;

export { Link$1 as default };
//# sourceMappingURL=index.js.map
